export const DOCS_HOME = 'https://docs.poly.ai/home';
export const DOCS_GET_STARTED =
  'https://docs.poly.ai/get-started/account-creation';
export const DOCS_TWILIO_INTEGRATION =
  'https://docs.poly.ai/telephony/twilio/how-to-integrate-voice';
export const DOCS_FUNCTION_LIBRARY =
  'https://docs.poly.ai/function/import-library';
export const DOCS_CONVERSATION_AND_FLOW_OBJECTS =
  'https://docs.poly.ai/flows/object';
export const DOCS_TOS = 'https://docs.poly.ai/legal/terms-of-service';
export const DOCS_PRIVACY = 'https://docs.poly.ai/legal/privacy-policy';
export const DOCS_CONTENT_FILTERS = '';
export const DOCS_TEST_SUITE =
  'https://docs.poly.ai/analytics/test-suite/introduction';
export const DOCS_SUPPORT =
  'https://poly-ai.atlassian.net/servicedesk/customer/portals';
export const JIRA_SUPPORT_URL =
  'https://poly-ai.atlassian.net/servicedesk/customer/portal/73';
